import React, { useEffect } from 'react';
import { Radio } from '@spark';
import {
    NO_LABELS_MODE_DEFAULT,
    noLabelsModeOptions,
} from '@/features/datasets/utils/hasLabelsHandling';

/**
 * Wizard Spark radios for unlabeled vs generate-with-AI when the has-labels
 * switch is OFF. Mirrors EmptyResponsesSection layout.
 */
const NoLabelsModeSection = ({
    value,
    onChange,
    taskType,
    titleSuffix = '',
}) => {
    const options = noLabelsModeOptions(taskType);
    const allowed = options.map((o) => o.value);
    const selected = allowed.includes(value) ? value : NO_LABELS_MODE_DEFAULT;
    const suffix = titleSuffix ? ` ${titleSuffix}` : '';
    const groupName = `no-labels-mode${titleSuffix || ''}`;

    useEffect(() => {
        if (!allowed.includes(value)) {
            onChange(NO_LABELS_MODE_DEFAULT);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, taskType]);

    return (
        <div className="cw-dc-field-row">
            <div className="cw-dc-field-row__label">
                <h3 className="cw-dc-section-title">
                    How would you like to proceed?
                    {suffix}
                </h3>
                <p className="cw-dc-field-row__desc">
                    Choose whether to import without responses or generate them with AI after
                    upload.
                </p>
            </div>
            <div className="cw-dc-field-row__controls">
                <div className="cw-dc-empty-responses" role="radiogroup" aria-label="No labels mode">
                    {options.map((opt) => (
                        <div key={opt.value} className="cw-dc-empty-responses__option">
                            <Radio
                                name={groupName}
                                value={opt.value}
                                label={opt.title}
                                status={selected === opt.value ? 'active' : 'inactive'}
                                onChange={() => onChange(opt.value)}
                            />
                            <p className="cw-dc-empty-responses__option-desc">{opt.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NoLabelsModeSection;
